import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';
import type { CardBackTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { useIsCardBackRedesignEnabled } from './useIsCardBackRedesignEnabled';

import * as styles from './CardBackLoading.module.less';

export const CardBackLoading: FunctionComponent = () => {
  const isRedesignEnabled = useIsCardBackRedesignEnabled();

  return (
    <div
      className={cx({
        [styles.cardDetailLoading]: true,
        [styles.cardBackRedesign]: isRedesignEnabled,
      })}
      data-testid={getTestId<CardBackTestIds>('card-back-loading')}
    >
      <Spinner centered={true} />
    </div>
  );
};
